import { TFunction } from 'i18next';
import { Sector } from 'graphql-common';
import TextCell from '@lib/components/Table/commonComponents/TextCell/TextCell';
import ChipCell from '@lib/components/Table/commonComponents/ChipCell/ChipCell';
import { CellProps, Column } from '@lib/components/Table/types';
import { colorToChipType } from '@lib/components/Chip/utils/colorEnum';

type ColumnsArgs = {
  t: TFunction<'translation', undefined>;
};

export default function getSectorsColumns({
  t,
}: ColumnsArgs): Column<Sector>[] {
  return [
    {
      id: 'code',
      Header: t('code'),
      accessor: 'code',
      Cell: (props: CellProps<Sector>) => <TextCell {...props} />,
      minWidth: 160,
      maxWidth: 220,
      width: 200,
      sortable: true,
    },
    {
      id: 'name',
      Header: t('sector-name'),
      accessor: 'name',
      Cell: ({ item }: CellProps<Sector>) => {
        const label = item?.name;
        const color = colorToChipType(item?.color);
        if (!label) return '-';
        return <ChipCell label={label} type={color} leftIcon="circle" />;
      },
      sortable: true,
    },
  ];
}
